import { computed, ref } from "vue";
import L from 'leaflet';
import * as turf from '@turf/turf';
import { searchHour, searchMax, searchMin, searchMinute, searchQuery, searchSecond, searchType, selectedGeoFence, selectedGroup, state } from "./SearchDevice";
import { auth_list, device_list, event_list, geofence_list, GET_SERVER_REQUEST, group_list, log_list, poi_list, user_list } from "./ServerConnect";
import { cpeList, nbUEList, updateMarkers } from "./MapSetting";
import { loginedUserData } from "./GlobalUtility";

// 📊 정렬 상태
export const sortStates = ref({
  user: [
    { id: 'user_id', order: 0 },
    { id: 'user_account', order: 0 },
    { id: 'user_name', order: 0 },
    { id: 'email', order: 0 },
    { id: 'role', order: 0 },
    { id: 'password_reset_required', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'updated_at', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  user_active: [
    { id: 'user_id', order: 0 },
    { id: 'user_account', order: 0 },
    { id: 'user_name', order: 0 },
    { id: 'email', order: 0 },
    { id: 'role', order: 0 },
    { id: 'password_reset_required', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'updated_at', order: 0 },
  ],
  user_deleted: [
    { id: 'user_id', order: 0 },
    { id: 'user_account', order: 0 },
    { id: 'user_name', order: 0 },
    { id: 'email', order: 0 },
    { id: 'role', order: 0 },
    { id: 'password_reset_required', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'updated_at', order: 0 },
  ],
  device: [
    { id: 'device_id', order: 0 },
    { id: 'device_name', order: 0 },
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'update_interval', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  device_active: [
    { id: 'device_id', order: 0 },
    { id: 'device_name', order: 0 },
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'update_interval', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  device_deleted: [
    { id: 'device_id', order: 0 },
    { id: 'device_name', order: 0 },
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'update_interval', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  group: [
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'device_count', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  group_active: [
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'device_count', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  group_deleted: [
    { id: 'group_id', order: 0 },
    { id: 'group_name', order: 0 },
    { id: 'device_count', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  geofence: [
    { id: 'geofence_id', order: 0 },
    { id: 'geofence_name', order: 0 },
    { id: 'data', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  geofence_active: [
    { id: 'geofence_id', order: 0 },
    { id: 'geofence_name', order: 0 },
    { id: 'data', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  geofence_deleted: [
    { id: 'geofence_id', order: 0 },
    { id: 'geofence_name', order: 0 },
    { id: 'data', order: 0 },
    { id: 'created_at', order: 0 },
  ],
  auth: [
    { id: 'auth_id', order: 0 },
    { id: 'auth_name', order: 0 },
    { id: 'geofences', order: 0 },
    { id: 'groups', order: 0 },
    { id: 'devices', order: 0 },
    { id: 'start_datetime', order: 0 },
    { id: 'end_datetime', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  auth_active: [
    { id: 'auth_id', order: 0 },
    { id: 'auth_name', order: 0 },
    { id: 'geofences', order: 0 },
    { id: 'groups', order: 0 },
    { id: 'devices', order: 0 },
    { id: 'start_datetime', order: 0 },
    { id: 'end_datetime', order: 0 },
  ],
  auth_deleted: [
    { id: 'auth_id', order: 0 },
    { id: 'auth_name', order: 0 },
    { id: 'geofences', order: 0 },
    { id: 'groups', order: 0 },
    { id: 'devices', order: 0 },
    { id: 'start_datetime', order: 0 },
    { id: 'end_datetime', order: 0 },
  ],
  poi: [
    { id: 'marker_id', order: 0 },
    { id: 'title', order: 0 },
    { id: 'description', order: 0 },
    { id: 'latitude', order: 0 },
    { id: 'longitude', order: 0 },
    { id: 'created_at', order: 0 },
    { id: 'modified_at', order: 0 },
    { id: 'is_deleted', order: 1 },
  ],
  enter_exit_records: [
    { id: 'event_id', order: 0 },
    { id: 'event_time', order: 0 },
    { id: 'state', order: 0 },
    { id: 'device_name', order: 0 },
    { id: 'action', order: 0 },
    { id: 'geofence_name', order: 0 },
  ],
  system_log: [
    { id: 'log_id', order: 0 },
    { id: 'type', order: 0 },
    { id: 'message', order: 0 },
    { id: 'description', order: 0 },
    { id: 'occurred_at', order: 0 },
  ],
  cpe: [
    { id: 'nb_ip', order: 0 },
    { id: 'state', order: 0 },
    { id: 'imsi', order: 0 },
    { id: 'msisdn', order: 0 },
    { id: 'latitude', order: 0 },
    { id: 'longitude', order: 0 },
  ],
});
// 🌀 정렬 상태 변경 함수
export const toggleSort = (tableKey, columnId) => {
  const target = sortStates.value[tableKey].find(col => col.id === columnId);
  if (!target) return;

  // 🔄 순환: 0(없음) → 1(asc) → 2(desc) → 0(없음)
  target.order = target.order === 0 ? 1 : target.order === 1 ? 2 : 0;

  // ✅ 다른 컬럼은 해제 (단일 정렬 기준 유지)
  sortStates.value[tableKey].forEach(col => {
    if (col.id !== columnId) col.order = 0;
  });

  // 장치, 그룹일 경우 정렬 초기화되면 삭제된 장치 뒤로 몰아넣기
  if (["user", "device", "group", "geofence", "poi"].includes(tableKey) && !sortStates.value[tableKey].find(col => col.order !== 0)) {
    sortStates.value[tableKey].find(col => col.id === 'is_deleted').order = 1;
  }
};
// 🗂️ 공통 정렬 함수
export const getSortedList = (list, tableKey) => {
  const sortColumn = sortStates.value[tableKey].find(col => col.order !== 0);
  if (!sortColumn) return list; // 정렬 없음

  return [...list].sort((a, b) => {
    if (typeof(a[sortColumn.id]) === 'number') {
      const valueA = a[sortColumn.id] ?? 0;
      const valueB = b[sortColumn.id] ?? 0;
      return sortColumn.order === 1 ? valueA - valueB : valueB - valueA;
    } else {
      const valueA = a[sortColumn.id]?.toString().toLowerCase() ?? '';
      const valueB = b[sortColumn.id]?.toString().toLowerCase() ?? '';
      return sortColumn.order === 1 ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    }
  });
};
// ✅ 정렬된 유저 목록
export const sortedUserList = computed(() => getSortedList(user_list.value, 'user'));
export const sortedActiveUserList = computed(() => getSortedList(user_list.value.filter(user => !user.is_deleted), 'user_active'));
// export const sortedDeletedUserList = computed(() => getSortedList(user_list.value.filter(user => user.is_deleted), 'user_deleted'));
// ✅ 정렬된 장치 목록
export const sortedDeviceList = computed(() => getSortedList(device_list.value, 'device'));
export const sortedActiveDeviceList = computed(() => getSortedList(device_list.value.filter(device => !device.is_deleted), 'device_active'));
// export const sortedDeletedDeviceList = computed(() => getSortedList(device_list.value.filter(device => device.is_deleted), 'device_deleted'));
// ✅ 정렬된 그룹 목록
export const sortedGroupList = computed(() => getSortedList(group_list.value, 'group'));
export const sortedActiveGroupList = computed(() => getSortedList(group_list.value.filter(group => !group.is_deleted), 'group_active'));
// export const sortedDeletedGroupList = computed(() => getSortedList(group_list.value.filter(group => group.is_deleted), 'group_deleted'));
// ✅ 정렬된 영역 목록
export const sortedGFList = computed(() => getSortedList(geofence_list.value, 'geofence'));
export const sortedActiveGFList = computed(() => getSortedList(geofence_list.value.filter(geo => !geo.is_deleted), 'geofence_active'));
// export const sortedDeletedGFList = computed(() => getSortedList(geofence_list.value.filter(geo => geo.is_deleted), 'geofence_deleted'));
// ✅ 정렬된 권한 목록
export const sortedAuthList = computed(() => getSortedList(auth_list.value, 'auth'));
export const sortedActiveAuthList = computed(() => getSortedList(auth_list.value.filter(auth => !auth.is_deleted), 'auth_active'));
// export const sortedDeletedAuthList = computed(() => getSortedList(auth_list.value.filter(auth => auth.is_deleted), 'auth_deleted'));
// ✅ 정렬된 POI 목록
export const sortedPOIList = computed(() => getSortedList(poi_list.value, 'poi'));
// ✅ 정렬된 출입 목록
export const sortedActiveEERList = computed(() => getSortedList(event_list.value, 'enter_exit_records'));
// ✅ 정렬된 로그 목록
export const sortedSLList = computed(() => getSortedList(log_list.value, 'system_log'));
// ✅ 정렬된 고정 위치 목록
export const sortedCpeList = computed(() => getSortedList(cpeList.value, 'cpe'));



export const sortKey = ref(""); // 정렬할 열
export const sortOrder = ref(0); // 1: 오름차순, -1: 내림차순
export const sortData = (column) => {
  if (sortKey.value === column) {
    if (sortOrder.value === 1) {
      sortOrder.value = -1; // 오름차순 → 내림차순
    } else if (sortOrder.value === -1) {
      sortKey.value = ""; // 초기화
      sortOrder.value = 0;
    }
  } else {
    sortKey.value = column;
    sortOrder.value = 1; // 새로운 키 정렬 시 기본 오름차순
  }
};

export const hoveredDeviceID = ref(new Set());
export const sortedData_locations = computed(() => {
  return [...state.locations].sort((a, b) => {
    // 1️⃣ 호버 중인 device_id를 먼저 정렬
    const aHovered = hoveredDeviceID.value.has(a.device_id);
    const bHovered = hoveredDeviceID.value.has(b.device_id);
    if (aHovered !== bHovered) return bHovered - aHovered; // true > false 순으로 정렬

    // 2️⃣ 기존 정렬 유지
    if (!sortKey.value) return 0;
    const valueA = a[sortKey.value];
    const valueB = b[sortKey.value];

    if (typeof valueA === "string") {
      return valueA.localeCompare(valueB) * sortOrder.value;
    }

    return (valueA - valueB) * sortOrder.value;
  });
});

export const filterObjects = async (data) => {
  let filteredData = data; // 기본적으로 모든 데이터를 할당
state.allLocations = data;
  const ud = await loginedUserData();
  if (ud.user_account !== 'user') {
    switch (searchType.value) {
      case 'deviceid':
        if (searchQuery.value) {
          filteredData = data.filter(device =>
            device.device_id.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
        }
        break;
      case 'devicename':
        if (searchQuery.value) {
          filteredData = data.filter(device =>
            device.device_name.toLowerCase().includes(searchQuery.value.toLowerCase())
          );
        }
        break;
      case 'groupname':
        if (selectedGroup.value) {
          const includeDevice = (await GET_SERVER_REQUEST("device", '/?group_id='.concat(selectedGroup.value)))
                                .map(d => d.device_id);
          filteredData = data.filter(device =>
            includeDevice.includes(device.device_id)
          );
        }
        break;
      case 'geofence':
        if (selectedGeoFence.value) {
          state.polygons = state.polygons.filter(poly => poly.geofence_id === selectedGeoFence.value);
          const geodata = state.polygons.find(polygon => polygon.geofence_id === selectedGeoFence.value).data;
          // GeoFence가 원일경우
          if (geodata.type.includes('circle#')) {
            const radius = parseFloat(geodata.type.split('#')[1]); // 반경 추출
            const center = geodata.locations[0]; // 원의 중심 (lat, lng)
  
            filteredData = data.filter(device => {
              const lat = parseFloat(device.latitude);
              const lng = parseFloat(device.longitude);
              if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                console.warn(`유효하지 않은 장치 좌표 (geofence-circle): ${device.device_id}, Lat: ${device.latitude}, Lng: ${device.longitude}`);
                return false;
              }

              const deviceLatLng = L.latLng(lat, lng);
              const centerLatLng = L.latLng(center.lat, center.lng);
              return deviceLatLng.distanceTo(centerLatLng) <= radius; // 반경 내 확인
            });
          } else { // GeoFence가 다각형일경우
            // ✅ 다각형(Polygon) 내부 확인 (Turf.js 사용)
            // ✅ 다각형(Polygon) 내부 확인 (첫 번째 좌표를 마지막에 추가)
            let polygonCoords = geodata.locations.map(loc => [loc.lat, loc.lng]);
  
            // 첫 번째 좌표를 마지막에 추가하여 폴리곤을 닫음
            if (
              polygonCoords.length > 0 &&
              (polygonCoords[0][0] !== polygonCoords[polygonCoords.length - 1][0] ||
              polygonCoords[0][1] !== polygonCoords[polygonCoords.length - 1][1])
            ) {
              polygonCoords.push(polygonCoords[0]);
            }
            const polygonGeoJSON = turf.polygon([polygonCoords]); // GeoJSON 폴리곤 생성
            filteredData = data.filter(device => {
              const lat = parseFloat(device.latitude);
              const lng = parseFloat(device.longitude);
              if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                console.warn(`유효하지 않은 장치 좌표 (geofence-circle): ${device.device_id}, Lat: ${device.latitude}, Lng: ${device.longitude}`);
                return false;
              }

              const point = turf.point([lat, lng]);
              return turf.booleanPointInPolygon(point, polygonGeoJSON);
            });
          }
        }
        break;
      case 'rsrp':
        filteredData = data.filter(device => {
          const level = device.lte_rsrp;
          return (!searchMin.value || level >= searchMin.value) &&
                 (!searchMax.value || level <= searchMax.value);
        });
        break;
      case 'battery':
        filteredData = data.filter(device => {
          const level = device.battery_level;
          return (!searchMin.value || level >= searchMin.value) &&
                 (!searchMax.value || level <= searchMax.value);
        });
        break;
      case 'lastctime': {
        const searchNow = new Date();
        const searchTime = new Date(searchNow.getTime() - (
          ((searchHour.value ? searchHour.value * 3600 : 0) + (searchMinute.value ? searchMinute.value * 60 : 0) + (searchSecond.value ? searchSecond.value : 0)) * 1000
        ));
        filteredData = data.filter(device => {
          if (new Date(device.timestamp) <= searchTime) return device;
        });
        break;
      }
      case 'backpack': {
        const targetIp = "20.10.12.25";
        // 1. nbUEList에서 nb_ip === targetIp 인 데이터만 골라냄
        const filtered = nbUEList.value.filter(item => item.nb_ip === targetIp);
        // 2. 그 데이터들의 msisdn 값만 추출
        const msisdnSet = new Set(filtered.map(item => item.msisdn));
        // 3. data 배열에서 msisdn 값이 일치하는 것만 골라냄
        const matched = data.filter(d => msisdnSet.has(d.msisdn));
        // 결과 저장
        filteredData = matched;

        break;
      }
    }
  } else {
    filteredData = data.filter(device =>
      device.device_id.toLowerCase().includes(searchQuery.value.toLowerCase())
      || device.device_name.toLowerCase().includes(searchQuery.value.toLowerCase())
    );
  }
  
  state.locations = filteredData;
  updateMarkers();

  if (searchQuery.value && state.locations.length > 0) {
    state.map.fitBounds(Object.values(state.locations)
              .flat() // 모든 단말기의 위치 배열을 하나로 합침
              .map(({ latitude, longitude }) => [latitude, longitude]));
  }
}